<template>
  <div class="training-reports-page">
    <app-page-header title="Relatório de Treinamentos">
      <button
        @click="exportTrainingReport()"
        :disabled="isExporting"
        class="export-btn"
        v-app-button.icon-left
      >
        <b-icon size="is-small" icon="download" />EXPORTAR
      </button>
    </app-page-header>

    <training-reports-table ref="trainingReportsTable"></training-reports-table>
  </div>
</template>

<script>
import TrainingReportsTable from '@/components/Tables/TrainingReportsTable.vue';
import TrainingResponsesService from '@/services/training-responses.service.js';

export default {
  name: 'training-reports-page',
  components: {
    TrainingReportsTable,
  },
  data: () => {
    return {
      isExporting: false,
    };
  },
  methods: {
    exportTrainingReport() {
      this.isExporting = true;

      const filters = this.$refs.trainingReportsTable.requestFilters;

      TrainingResponsesService.export(filters)
        .then(({ data }) => {
          const link = document.createElement('a');
          link.target = '_blank';
          link.href = data.url;
          link.click();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao realizar exportação.',
            'error'
          );
        })
        .finally(() => (this.isExporting = false));
    },
  },
};
</script>
